<ng-container *transloco="let t">
  <div class="row text-center justify-content-center mt-3">
    <form id="inputForm" [formGroup]="inputForm" (ngSubmit)="submit()" [hidden]></form>
    <ng-container *ngIf="outcomeValue$ | async as outcomeValue">
      <p class="w-100" *ngIf="outcomeValue.result">{{outcomeValue.result ? t('common.success') : t('common.fail')}}</p>
      <p class="w-100">{{t('common.progress')}}: {{outcomeValue.progress}}%</p>
    </ng-container>
  </div>
</ng-container>
